import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals/attribution'

const PAYLOAD_VERSION = 1
const TARGET_MAX_LENGTH = 160

export const sanitizeWebVitalsTarget = target => {
  if (!target) return ''
  const withoutControlCharacters = Array.from(String(target), character => {
    const code = character.charCodeAt(0)
    return code <= 31 || code === 127 ? ' ' : character
  }).join('')
  return withoutControlCharacters
    .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[redacted-email]')
    .replace(/\[([^\]=\s]+)\s*=\s*(['"]).*?\2\]/g, '[$1]')
    .replace(/([?&](?:email|phone|token|key|auth)=)[^&#\s]+/gi, '$1[redacted]')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, TARGET_MAX_LENGTH)
}

const getNavigationType = wnd => {
  const navigation = wnd.performance?.getEntriesByType?.('navigation')?.[0]
  return navigation?.type || 'navigate'
}

export const createWebVitalsReporter = (wnd = window) => {
  const pagePath = wnd.location.pathname
  const hostname = wnd.location.hostname
  const initialNavigationType = getNavigationType(wnd)

  return ({ name, delta, value, id, rating, navigationType, attribution }) => {
    let rawTarget = ''
    if (name === 'CLS') rawTarget = attribution?.largestShiftTarget
    if (name === 'INP') rawTarget = attribution?.interactionTarget
    if (name === 'LCP') rawTarget = attribution?.element
    const target = sanitizeWebVitalsTarget(rawTarget)
    const eventParams = {
      value: delta,
      web_vitals_id: id,
      web_vitals_value: value,
      web_vitals_delta: delta,
      web_vitals_load_state: attribution?.loadState || '',
      web_vitals_page_path: pagePath,
      web_vitals_page_hostname: hostname,
      web_vitals_navigation_type: navigationType || initialNavigationType,
      web_vitals_rating: rating || '',
      web_vitals_payload_version: PAYLOAD_VERSION,
      web_vitals_target: target,
    }

    if (name === 'CLS' || name === 'INP' || name === 'LCP') {
      eventParams.web_vitals_debug_target = target
    }

    if (name === 'INP') {
      eventParams.web_vitals_debug_interaction_type = attribution?.interactionType
      eventParams.web_vitals_input_delay = attribution?.inputDelay
      eventParams.web_vitals_processing_duration = attribution?.processingDuration
      eventParams.web_vitals_presentation_delay = attribution?.presentationDelay
    }

    wnd.gtag('event', name, eventParams)
  }
}

export const initWebVitals = (wnd = window) => {
  if (wnd.__webVitalsObserversInitialized) return
  wnd.__webVitalsObserversInitialized = true
  const report = createWebVitalsReporter(wnd)

  onCLS(report)
  onINP(report, { reportAllChanges: true })
  onLCP(report)
  onFCP(report)
  onTTFB(report)
}
